const isDevelopment = () =>
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const _log = (...optional: unknown[]) => {
  // Normal log if in development
  if (isDevelopment()) {
    console.log(...optional);
  }
};

export const _elog = (...optional: unknown[]) => {
  // Error log if in development
  if (isDevelopment()) {
    console.error(...optional);
  }
};

export const _wlog = (...optional: unknown[]) => {
  // Warning log if in development
  if (isDevelopment()) {
    console.warn(...optional);
  }
};
